import { render, staticRenderFns } from "./FosterDashboardPane.vue?vue&type=template&id=695e87ad&scoped=true&"
import script from "./FosterDashboardPane.vue?vue&type=script&lang=js&"
export * from "./FosterDashboardPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695e87ad",
  null
  
)

export default component.exports